import { React, useState, useEffect } from 'react';
import Nav from './nav';
import './tabs.css';
import Card from './card';
import Transcript from './bulletin';
import { Form, useNavigate } from 'react-router-dom';
import Receipt from './receipt.js';
import SearchDoc from './search.js';
import UploaDoc from './upload.js';
import UNILISUNDDiplomaTemplate from './templates/UNILISUNDDiploma/UNILISUNDDiplomaTemplate.js';
import UNILISUNDDiplomaSansTemplate from './templates/UNILISUNDDiplomaSans/UNILISUNDDiplomaSansTemplate.js';
import UNILISUNDMasterTemplate from './templates/UNILISUNDMaster/UNILISUNDMasterTemplate.js';
import EthosCertificateTemplate from './templates/EthosCertificate/EthosCertificateTemplate.js';
import AttestationDirectionTemplate from './templates/AttestationDirection/AttestationDirectionTemplate.js';

function Tab() {
  const [activeTab, setActiveTab] = useState('Tab1');
  const navigate = useNavigate();

  useEffect(() => {
    switch (activeTab) {
      case 'Tab1':
        document.title = 'EDAP-UNILIS';
        break;
      case 'Tab2':
        document.title = 'Bulletin Academique';
        break;
      case 'Tab3':
        document.title = 'Reçu de Paiement';
        break;
      case 'Tab4':
        document.title = 'Diplôme UND - UNILIS';
        break;
      case 'Tab5':
        document.title = 'Master UND - UNILIS';
        break;
      case 'Tab6':
        document.title = 'Diplôme UND Sans - UNILIS';
        break;
      case 'Tab7':
        document.title = 'Ethos Cert. Communication';
        break;
      case 'Tab8':
        document.title = 'Attestation Direction';
        break;
      default:
        document.title = 'Admin';
    }
  }, [activeTab]);

  const enter = () => {
    navigate('/gen')
  }
  return (
    <div className="tab-page">
      <Nav />
      <br />
      <br />
      <div className="tab-container">
        <div className="tabs">
          <button
            className={activeTab === 'Tab1' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab1')}
          >
            Carte Etudiant
          </button>
          <button
            className={activeTab === 'Tab2' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab2')}
          >
            Bulletin Academique
          </button>
          <button
            className={activeTab === 'Tab3' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab3')}
          >
            Reçu de Paiement
          </button>
          <button
            className={activeTab === 'Tab4' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab4')}
          >
            Diplôme UND
          </button>
          <button
            className={activeTab === 'Tab5' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab5')}
          >
            Master UND
          </button>
          <button
            className={activeTab === 'Tab6' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab6')}
          >
            Diplôme UND Sans
          </button>
          <button
            className={activeTab === 'Tab7' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab7')}
          >
            Ethos Cert. Communication
          </button>
          <button
            className={activeTab === 'Tab8' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab8')}
          >
            Attestation Direction
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'Tab1' && <div className="content"><Card /></div>}
          {activeTab === 'Tab2' && <div className="content"><Transcript /></div>}
          {activeTab === 'Tab3' && <div className="content"><Receipt /></div>}
          {activeTab === 'Tab4' && <div className="content"><UNILISUNDDiplomaTemplate /></div>}
          {activeTab === 'Tab5' && <div className="content"><UNILISUNDMasterTemplate /></div>}
          {activeTab === 'Tab6' && <div className="content"><UNILISUNDDiplomaSansTemplate /></div>}
          {activeTab === 'Tab7' && <div className="content"><EthosCertificateTemplate /></div>}
          {activeTab === 'Tab8' && <div className="content"><AttestationDirectionTemplate /></div>}
        </div>
      </div>
      <footer>G.A.P 2024 © All Rights Reserved.</footer>
    </div>
  );
}

export default Tab;